// "Enterprise Security Solo: 7 Layers, DB-Level Isolation" — multi-tenant security short.
// Cold Compute / Neon kit. ~122s @ 30fps.
// Story: RLS is the load-bearing layer. One missed WHERE clause = a cross-tenant
// breach — but the Postgres engine enforces tenant_id at the row level, so the
// query physically cannot return another tenant's rows.
export { FPS, WIDTH, HEIGHT } from "../../coldcompute/theme";

// Scene frame-timing map. start/duration in frames; contiguous (next.start = prev.start + prev.duration).
export const SCENE = {
  hook: { start: 0, duration: 180 }, //          0:00–0:06  one missed WHERE = breach
  pyramid: { start: 180, duration: 540 }, //     0:06–0:24  5-layer defense-in-depth
  rls: { start: 720, duration: 420 }, //         0:24–0:38  Layer 3 — RLS is the big one
  code: { start: 1140, duration: 720 }, //       0:38–0:62  the real mig 194 RLS policy
  failclosed: { start: 1860, duration: 420 }, // 0:62–0:76  RLS ON + no policy = deny-all
  everywhere: { start: 2280, duration: 540 }, // 0:76–0:94  tenant_id in 8 places
  payoff: { start: 2820, duration: 480 }, //     0:94–1:50  the engine catches the bug
  outro: { start: 3300, duration: 360 }, //      1:50–2:02
} as const;

export const TOTAL_DURATION = 3660; // 122s

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
